
import { Utils } from "../../utils";
import React, { ReactNode } from "react";
import { PlanUpSell, PlanValue } from "@syllektis/oya-gbewa-react";
import { ChangePlan } from "../sections/account_settings/plan_and_billing/ManagePlan";

export interface UpSellPlanProps {
    type?: any;
    icon?: any;
    styles?: any;
    alignment?: any;
    planLevel?: number;
    capability?: string;
    children: ReactNode;
    successOnNoop?: boolean;
    currentValue?: PlanValue;
    childrenRelayProps?: any;
    actionCapability?: string;
    processingView?: ReactNode;
    style?: React.CSSProperties;
    overrideNestedClickEvents?: boolean;
}

function UpSellPlan(props: UpSellPlanProps) {

    // if (true) { feature flag
    //     return props.children;
    // }

    return (<PlanUpSell {...props} action={(e) => ChangePlan.upSell({ profile: Utils.PROFILE, ...e, capability: props.capability ?? props.actionCapability ?? e.capability })} >
        {props.children}
    </PlanUpSell>);

}

export default UpSellPlan;
